import React from 'react';
import { Link } from 'react-router-dom';
import projectData from '../../data/projects.json';

const Projects = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    // Get last 4 projects and map to required format
    const lastFourProjects = projectData.projects.slice(-4).map(project => ({
        pImg: project.thumbnailImage 
               ? require(`../../images/${project.thumbnailImage}`) 
               : require(`../../images/${project.mainImage}`), // Fallback to main image
        title: project.title,
        link: `/project-single/${project.slug}`
    }));

    return(
        <section className="wpo-gallery-section section-padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-sm-8">
                        <div className="wpo-section-title">
                            <span>Products</span>
                            <h2>Our Products Gallery</h2>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-4">
                        <div className="wpo-section-title-button">
                            <Link onClick={ClickHandler} to="/project">More Products</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col col-xs-12 sortable-gallery">
                        <div className="wpo-gallery-container">
                            {lastFourProjects.map((project, index) => (
                                <div className="grid" key={index}>
                                    <div className="wpo-gallery-item">
                                        <Link onClick={ClickHandler} to={project.link}>
                                            <img 
                                                src={project.pImg} 
                                                alt={project.title} 
                                                className="img img-responsive"
                                                style={{
                                                    width: '100%',
                                                    height: '300px', 
                                                    objectFit: 'cover' 
                                                }}
                                            />
                                            <div className="wpo-gallery-text">
                                                <h3  style={{
                                                position: 'absolute',
                                                bottom: '0',
                                                left: '0',
                                                right: '0',
                                                textAlign: 'center',
                                                padding: '20px',
                                                background: 'rgba(0,0,0,0.5)',
                                                color: '#fff'}}>{project.title}</h3>
                                                <i className="ti-plus"></i>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div> 
            </div>
        </section>
    )
}

export default Projects;